<script lang="ts" setup>
    import type { PrimaryButtonProps } from '~/components/basics/PrimaryButton.vue';
    import docCheckIcon from '~/assets/images/docCheck.png';

    const {
        text = 'DocCheck Login',
        size,
        retainSize,
        alignment
    } = defineProps<{ text?: string } & Pick<PrimaryButtonProps, 'size' | 'retainSize' | 'alignment'>>();

    const { login } = useLoginState();
    const { getPostLoginUrl } = usePostLoginUrl();

    const handleClick = async () => {
        await login({ method: 'doccheck', redirectTo: await getPostLoginUrl() });
    };
</script>

<template>
    <PrimaryButton
        :aria-label="text"
        :button-text="text"
        native-button
        variant="secondary"
        :size="size"
        :retain-size="retainSize"
        :alignment="alignment"
        @click="handleClick"
    >
        <template #customIcon>
            <img
                :src="docCheckIcon"
                alt=""
                aria-hidden="true"
            />
        </template>
    </PrimaryButton>
</template>
